const stringsES = {
  'general.loggingIn': 'Iniciando sesión...',
  'general.invalidPassword': 'Contraseña no válida, intenta otra vez',
  'general.goToLogin': 'Ir a "iniciar sesión"',
  'general.loggedOutText': 'Has sido desconectado',
  'general.changePassword': 'Cambiar contraseña',
  'general.modified': 'Modificado',
  'general.mobile': 'Móvil',
  'general.desktop': 'Escritorio',
  'general.backTo': 'Volver',
  'general.synced': 'Sincronizado',
  'general.assigned': 'asignado',
  'general.notAssigned': 'no asignado',
  'menuLabel.notesAndDocuments': 'Notas y documentos',
  'plants.filterByTag': 'Filtrar por tag',
  'plants.recentlyModified': 'ordenar por modificaciones recientes',
  'plants.plantName': 'ordenar por nombre de instalación',
  'newPlantDialog.insertGroup': '+ añadir un nuevo grupo y presionar Intro',
  'plantDetail.addDevice': 'Añadir dispositivo',
  'plantDetail.addObjects': 'Añadir objetos',
  'plants.noPlantsHint':
    'Pincha en "Nueva instalación" para crear una nueva instalación',
  'plantDetail.newUpdates': 'Nuevas actualizaciones',
  'plantDetail.willRefreshToReflectChanges':
    'Este elemento ha sido actualizado. La página se actualizará para reflejar los cambios.',
  'plantDetail.addGroup': 'Añadir grupo',
  'plantDetail.addScene': 'Añadir escenario',
  'plantC300EOSSettings.GeneralSettings': 'Ajustes generales',
  'plantC300EOSSettings.DoorEntryParametrs': 'PARÁMETROS DE VIDEOPORTERO',
  'plantC300EOSSettings.descPage':
    'No se puede modificar todos los parámetros para esta sección: tienes que hacerlo in-situ desde la aplicación conectada',
  'general.favourites': 'Favoritos',
  'general.select': 'Seleccionar',
  'general.operationError': 'Error en la operación',
  'plantDetail.lastScan': 'Último escaneo: {date} a las {time}',
  'general.assignIcon': 'Asignar el icono',
  'general.assignedIcon': 'Icono asignado',
  'newPlantDialog.modified': 'Instalación modificada',
  'plantDetail.deletePlantConfirm':
    '¿Estás seguro que quieres suprimir {plantName}? Se perderán todos los datos. Para suprimir, insertar el código {code} y confirmar',
  'plantDetail.objectsCreated': 'Objetos creados con éxito',
  'plantDetail.selectDevice': 'Selecciona un dispositivo para ver sus módulos',
  'plantDetail.typeNameGroup': 'Tipo y nombre del grupo',
  'plantDetail.disableScene': 'Deshabilitar escenario',
  'plantDetail.disableSceneConfirm':
    '¿Estás seguro que quieres deshabilitar el escenario "{sceneName}"?',
  'plantC300EOSSettings.SetAsPrimaryEntryUnitDESC':
    'La unidad externa principal es la única que transfiere la llamada desde la app y gestiona el contestador',
  'plantC300EOSSettings.ProfessionalStudioDESC':
    'Cuando lo habilita el usuario, el estudio profesional abre automáticamente la cerradura de la puerta cada vez que alguien llama',
  'scenes.trigger': 'disparador',
  'uniqueNaming.validationError': 'Nombre no válido',
  'uniqueNaming.unavailableName': 'Nombre no disponible',
  'uniqueNaming.roomInlineNamingError':
    'No ha sido posible actualizar el nombre',
  'uniqueNaming.roomInlineNamingSuccess': 'Nombre de la habitación actualizado',
  'uniqueNaming.nameResetDisclaimer': 'El nombre se reiniciará al inicial',
  'uniqueNaming.validationErrorWithSuggestion':
    'Nombre no válido, puedes intentar con: "{suggestedName}"',
  'plantsList.duplicateDialog.inputLabel':
    'Puedes ajustar los nombres de las instalaciones aquí',
  'plantDialogDuplicate.howManyCopies': 'Cuántas copias',
  'plantDialogDuplicate.success': 'Instalación duplicada',
  'general.actuatorAdded': 'Actuador añadido',
  'general.commandAdded': 'Comando añadido',
  isEditingPlant: 'está modificando la configuración',
  eliotParseException:
    'Problema en la lectura de la configuración de la instalación desde cloud.', // assignObject: {
  //   selectFromLastScan: 'Select from last scan',
  //   selectFromCatalogue: 'Select from catalogue',
  // },
  // assignThermo: {
  //   selectOnlyOneDescription:
  //     'TEMP STRING You should select one and only one device.',
  //   thermostatAdded: 'Thermostat added',
  //   heatingActuatorAdded: 'Heating actuator added',
  //   coolingActuatorAdded: 'Cooling actuator added',
  //   sharedActuatorAdded: 'Shared actuator added',
  //   heatingPumpAdded: 'Heating pump added',
  //   coolingPumpAdded: 'Cooling pump added',
  //   sharedPumpAdded: 'Shared pump added',
  //   probeAdded: 'Probe added',
  // },
};
export default stringsES;
